import { Injectable, inject } from '@angular/core';

import { DisplayType } from '@cds/betting-offer';
import { EventOptionGroup, EventOptionGroupType, ExtendedDisplayType } from '@frontend/sports/betting-offer/feature/model';
import { MarketGroupingConfig } from '@frontend/sports/common/client-config-data-access';

export enum OptionGroupType {
    Regular = 'Regular',
    CorrectScore = 'CorrectScore',
    Period = 'Period',
    OverUnder = 'Over/Under',
    GoalScorer = 'GoalScorer',
    SixPack = 'SixPack',
    PlayerProps = 'PlayerProps',
    Spread = 'Spread',
    Scorecast = 'Scorecast',
    Wincast = 'Wincast',
    WincastParticipant = 'WincastParticipant',
    RaceTo = 'RaceTo',
    Outrights = 'Outrights',
    YesNo = 'YesNo',
    TotalScore = 'TotalScore',
    Head2Head = 'Head2Head',

    BTTS = 'BTTS',

    PrecreatedBuildABet = 'PrecreatedBuildABet',
    BetBuilderStandard = 'BetBuilderStandard',
    BetBuilderSixPack = 'BetBuilderSixPack',
    BetBuilderOverUnder = 'BetBuilderOverUnder',
    BetBuilderCorrectScore = 'BetBuilderCorrectScore',
    BetBuilderSpread = 'BetBuilderSpread',
    BetBuilderRaceTo = 'BetBuilderRaceTo',
    BetBuilderGoalScorer = 'BetBuilderGoalScorer',
    BetBuilderYesNo = 'BetBuilderYesNo',
    BetBuilderPlayerProps = 'BetBuilderPlayerProps',
    PlayerCombined = 'PlayerCombined',
    PlayerMilestone = 'PlayerMilestone',

    USGroupedList = 'USGroupedList',
    USCorrectScore = 'USCorrectScore',
    PlayerStats = 'PlayerStats',
    PlayerOutcome = 'PlayerOutcome',
    PlayerMilestoneOverUnder = 'PlayerMilestoneOverUnder',
}

@Injectable({ providedIn: 'root' })
export class OptionGroupTypeService {
    private marketGroupingConfig = inject(MarketGroupingConfig);

    // eslint-disable-next-line max-lines-per-function, complexity
    getOptionGroupType(optionGroup: EventOptionGroup): OptionGroupType {
        if (optionGroup.hasSubGroups(EventOptionGroupType.Period) && optionGroup.detailedGrouping?.displayType !== ExtendedDisplayType.BetBuilder) {
            return OptionGroupType.Period;
        }

        const isDisplayTypeMatched = this.marketGroupingConfig.displayTypes?.includes(optionGroup.detailedGrouping?.displayType);

        //TODO please consider refactoring

        switch (optionGroup.detailedGrouping?.displayType) {
            case DisplayType.CorrectScore:
                return OptionGroupType.CorrectScore;
            case DisplayType.GoalScorer:
                return OptionGroupType.GoalScorer;
            case DisplayType.OverUnder:
                return OptionGroupType.OverUnder;
            case ExtendedDisplayType.BetBuilder:
                return OptionGroupType.PrecreatedBuildABet;
            case ExtendedDisplayType.BetBuilderStandard:
                return OptionGroupType.BetBuilderStandard;
            case ExtendedDisplayType.BetBuilderSixPack:
                return OptionGroupType.BetBuilderSixPack;
            case ExtendedDisplayType.BetBuilderOverUnder:
                return OptionGroupType.BetBuilderOverUnder;
            case ExtendedDisplayType.BetBuilderCorrectScore:
                return OptionGroupType.BetBuilderCorrectScore;
            case ExtendedDisplayType.BetBuilderSpread:
                return OptionGroupType.BetBuilderSpread;
            case ExtendedDisplayType.BetBuilderRaceTo:
                return OptionGroupType.BetBuilderRaceTo;
            case ExtendedDisplayType.BetBuilderYesNo:
                return OptionGroupType.BetBuilderYesNo;
            case ExtendedDisplayType.BetBuilderGoalScorer:
                return OptionGroupType.BetBuilderGoalScorer;
            case ExtendedDisplayType.BetBuilderPlayerProps:
                return OptionGroupType.BetBuilderPlayerProps;
            case DisplayType.PlayerProps:
                return OptionGroupType.PlayerProps;
            case DisplayType.Regular:
                return OptionGroupType.Regular;
            case DisplayType.Head2HeadSixPack:
            case DisplayType.SixPack:
                return OptionGroupType.SixPack;
            case DisplayType.Spread:
                return OptionGroupType.Spread;
            case DisplayType.Scorecast:
                return OptionGroupType.Scorecast;
            case DisplayType.Wincast:
                return OptionGroupType.Wincast;
            case DisplayType.WincastParticipant:
                return OptionGroupType.WincastParticipant;
            case DisplayType.RaceTo:
                return OptionGroupType.RaceTo;
            case DisplayType.BTTS:
                return OptionGroupType.BTTS;
            case DisplayType.YesNo:
                return OptionGroupType.YesNo;
            case DisplayType.Outrights:
                return OptionGroupType.Outrights;
            case DisplayType.TotalScore:
                return OptionGroupType.TotalScore;
            case DisplayType.Head2Head:
                return OptionGroupType.Head2Head;
            case DisplayType.PlayerCombined:
                return OptionGroupType.PlayerCombined;
            case DisplayType.PlayerMilestone:
                return OptionGroupType.PlayerMilestone;
            case DisplayType.PlayerMilestoneOverUnder:
                return OptionGroupType.PlayerMilestoneOverUnder;
            case DisplayType.PlayerOutcome:
                return OptionGroupType.PlayerOutcome;
            case DisplayType.USGroupedList:
                if (isDisplayTypeMatched) {
                    return OptionGroupType.USGroupedList;
                }
                return OptionGroupType.Regular;
            case DisplayType.USCorrectScore:
                if (isDisplayTypeMatched) {
                    return OptionGroupType.CorrectScore;
                }
                return OptionGroupType.Regular;
            case DisplayType.PlayerStats:
                return OptionGroupType.PlayerStats;
            default:
                return OptionGroupType.Regular;
        }
    }
}
